

export const demo=state=>state.demo;   // 




// WEBPACK FOOTER //
// ./src/vuex/getters.js